import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, InputGroup, CustomInput, Button } from 'reactstrap';
import { locationActions } from '../_actions';

function FindLocation(props) {
  const { getLocationsAndStates, locations, history } = props;
  console.log(locations);
  const [selectedLocation, setSelectedLocation] = useState(0);

  useEffect(() => {
    getLocationsAndStates();
  }, [getLocationsAndStates]);

  return (
    <Container>
      <Row>
        <Col xs={12}>
          <p className="text-center pb-2" style={{color: '#8E8E8E', fontWeight: 500, fontSize: '0.8rem'}}>Select Your Course</p>
        </Col>
        <Col>
          {locations && (
            <>
              <InputGroup>
                <CustomInput
                  className="rounded-select"
                  type="select"
                  id="stateselect"
                  name="stateId"
                  onChange={e => setSelectedLocation(e.target.value)}
                  value={selectedLocation}
                  required
                >
                  <option value="0">Select Your Course</option>
                  {locations.map((s, idx) => (
                    <option key={idx} value={s.path}>
                      {s.name}
                    </option>
                  ))}
                </CustomInput>
              </InputGroup>
              <Button
                style={{
                  width: '100%',
                  backgroundColor: '#62B522',
                  borderRadius: '1.5rem',
                  marginTop: 10,
                  paddingTop: 10,
                  paddingBottom: 10,
                  fontWeight: 500,
                  fontSize: '1rem',
                  border: 'none',
                }}
                disabled={selectedLocation === 0}
                onClick={() => history.push(`/Locations/View/${selectedLocation}/`)}
              >
                GO TO COURSE
              </Button>
            </>
          )}
        </Col>
      </Row>
    </Container>
  );
}

function mapStateToProps(state) {
  const { locations } = state.location;
  return { locations };
}
const mapDispatchToProps = {
  getLocationsAndStates: locationActions.getLocationsAndStates,
};
const connectedFindLocation = connect(
  mapStateToProps,
  mapDispatchToProps
)(FindLocation);

export { connectedFindLocation as FindLocation };
